import { useMemo } from "react";
import { useLocation } from "react-router-dom";

import {
  Sidebar,
  SidebarHeader,
  SidebarFooter,
  SidebarBody,
  SidebarItem,
  SidebarLabel,
  SidebarSection,
  SidebarSpacer,
} from "V2.0/common/sidebarCatalyst";
import { WorkspaceSwitcher } from "V2.0/HomePages/Workspaces/Workspace_switcher";
import { UserMenu } from "./User_menu";

import CompanyLogo from "./CompanyLogo";

export function SidebarNavigation(props) {
  const {
    projects,
    activeProject,
    setActiveProject,
    user,
    firstNameShort,
    setIsOpen,
    company,
    loading,
    roleAccessBasedNavigationItems
  } = props;

  const location = useLocation();

  const navigationItems = roleAccessBasedNavigationItems.map((nav) => ({
    ...nav,
    current: nav.href === location.pathname.split("/")[1],
  }));

  const hideLogo = localStorage.getItem("hideLogo") === "true";

  return (
    <Sidebar>
      {!hideLogo && (
        <SidebarHeader>
          <div className="flex items-center my-0">
            <CompanyLogo company={company} />
          </div>
        </SidebarHeader>
      )}
      <SidebarBody>
        <SidebarSection>
          <WorkspaceSwitcher
            projects={projects}
            activeProject={activeProject}
            setActiveProject={setActiveProject}
            setIsOpen={setIsOpen}
            loading={loading}
            user={user}
          />
          <SidebarSpacer />
        </SidebarSection>
        {navigationItems.map((item) => (
          <SidebarItem
            key={item.href}
            to={{
              pathname: item.href,
              search: `?projectId=${new URLSearchParams(location.search).get("projectId")}`
            }}
            current={item.current}
            active={item.current}
          >
            {item.icon}
            <SidebarLabel>{item.name}</SidebarLabel>
          </SidebarItem>
        ))}
      </SidebarBody>
      <SidebarFooter>
        {/*<UserMenu initials={firstNameShort} user={user} /> /*TODO*/}
        <UserMenu initials={""} user={user} company={company} />
      </SidebarFooter>
    </Sidebar>
  );
}
